import { User, userKey } from "../../model/User";

export const getLocalUser = (): User | undefined => {
  const localUser = localStorage.getItem(userKey);
  return localUser ? (JSON.parse(localUser) as User) : undefined;
};
